import React, { Component } from 'react';
import { FormControl } from 'react-bootstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';

export default class StateComboBox extends Component {
  constructor(props) {
    super(props);

    /* istanbul ignore next */
    this.usStateList = [
      { abrv: 'AL', name: 'Alabama' },
      { abrv: 'AK', name: 'Alaska' },
      { abrv: 'AS', name: 'American Samoa' },
      { abrv: 'AZ', name: 'Arizona' },
      { abrv: 'AR', name: 'Arkansas' },
      { abrv: 'CA', name: 'California' },
      { abrv: 'CO', name: 'Colorado' },
      { abrv: 'CT', name: 'Connecticut' },
      { abrv: 'DE', name: 'Delaware' },
      { abrv: 'DC', name: 'District Of Columbia' },
      { abrv: 'FM', name: 'Federated States Of Micronesia' },
      { abrv: 'FL', name: 'Florida' },
      { abrv: 'GA', name: 'Georgia' },
      { abrv: 'GU', name: 'Guam' },
      { abrv: 'HI', name: 'Hawaii' },
      { abrv: 'ID', name: 'Idaho' },
      { abrv: 'IL', name: 'Illinois' },
      { abrv: 'IN', name: 'Indiana' },
      { abrv: 'IA', name: 'Iowa' },
      { abrv: 'KS', name: 'Kansas' },
      { abrv: 'KY', name: 'Kentucky' },
      { abrv: 'LA', name: 'Louisiana' },
      { abrv: 'ME', name: 'Maine' },
      { abrv: 'MH', name: 'Marshall Islands' },
      { abrv: 'MD', name: 'Maryland' },
      { abrv: 'MA', name: 'Massachusetts' },
      { abrv: 'MI', name: 'Michigan' },
      { abrv: 'MN', name: 'Minnesota' },
      { abrv: 'MS', name: 'Mississippi' },
      { abrv: 'MO', name: 'Missouri' },
      { abrv: 'MT', name: 'Montana' },
      { abrv: 'NE', name: 'Nebraska' },
      { abrv: 'NV', name: 'Nevada' },
      { abrv: 'NH', name: 'New Hampshire' },
      { abrv: 'NJ', name: 'New Jersey' },
      { abrv: 'NM', name: 'New Mexico' },
      { abrv: 'NY', name: 'New York' },
      { abrv: 'NC', name: 'North Carolina' },
      { abrv: 'ND', name: 'North Dakota' },
      { abrv: 'MP', name: 'Northern Mariana Islands' },
      { abrv: 'OH', name: 'Ohio' },
      { abrv: 'OK', name: 'Oklahoma' },
      { abrv: 'OR', name: 'Oregon' },
      { abrv: 'PW', name: 'Palau' },
      { abrv: 'PA', name: 'Pennsylvania' },
      { abrv: 'PR', name: 'Puerto Rico' },
      { abrv: 'RI', name: 'Rhode Island' },
      { abrv: 'SC', name: 'South Carolina' },
      { abrv: 'SD', name: 'South Dakota' },
      { abrv: 'TN', name: 'Tennessee' },
      { abrv: 'TX', name: 'Texas' },
      { abrv: 'UT', name: 'Utah' },
      { abrv: 'VT', name: 'Vermont' },
      { abrv: 'VI', name: 'Virgin Islands' },
      { abrv: 'VA', name: 'Virginia' },
      { abrv: 'WA', name: 'Washington' },
      { abrv: 'WV', name: 'West Virginia' },
      { abrv: 'WI', name: 'Wisconsin' },
      { abrv: 'WY', name: 'Wyoming' },
    ];
  }

  render() {
    const stateList = [];
    _.forEach(this.usStateList, (item, i) => {
      stateList.push(<option key={i} value={item.abrv}>{item.name}</option>);
    });

    return (
      <FormControl className="stateComboBoxControl" name={this.props.name} value={this.props.selected} componentClass="select" onChange={this.props.onChange} placeholder="select">
        <option value="" disabled>Select a state</option>
        {stateList}
      </FormControl>
    );
  }
}

StateComboBox.propTypes = {
  name: PropTypes.string,
  selected: PropTypes.string,
  onChange: PropTypes.func,
};
